<template>
  <div
    class="instagram-card"
    :class="{ 'instagram-card_active': isHover }"
    @click="handlerOpenModal"
    @mouseenter="isHover = true"
    @mouseleave="isHover = false"
  >
    <DefImg :result="result.pictures.collection" />
    <div class="instagram-card-effect">
      <p class="instagram-card-effect__name">{{ result.instagramName }}</p>
      <p class="instagram-card-effect__quantity">
        <svg class="instagram-card-effect__favourite"><use xlink:href="#svg-like"></use></svg>
        {{ result.likesQuantity }}
      </p>
    </div>
    <LookButton :is-hover="isHover">
      {{ messages.watchTheLook }}
    </LookButton>
  </div>
</template>

<script lang="ts" setup>
import InstagramModal from '@components/sliders/InstagramLooks/InstagramModal/InstagramModal.vue';
import useModal from '@use/useModal/useModal';
import DefImg from '@components/Def/DefImg/DefImg.vue';
import { ref } from 'vue';
import LookButton from '@components/Look/LookButton.vue';

const props = defineProps(['result', 'messages']);

const isHover = ref(false);

const modal = useModal();
const handlerOpenModal = () => {
  modal.show(
    InstagramModal,
    { result: props.result },
    {
      width: '852px',
    }
  );
};
</script>

<style lang="scss" scoped>
.instagram-card {
  position: relative;
  cursor: pointer;
  &_active {
    .instagram-card-effect {
      opacity: 1;
    }
  }
}
.instagram-card-effect {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(2.5px);
  line-height: 125%;
  color: #fff;
  opacity: 0;
  transition: 0.2s linear opacity;
  &__favourite {
    width: 20px;
    height: 20px;
    fill: #fff;
  }
  &__name {
    font-size: 18px;
    font-weight: 500;
  }
  &__quantity {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 16px;
    font-weight: 600;
  }
}
</style>
